// extracted by mini-css-extract-plugin
module.exports = {"rating":"DynamicRating_rating_gvAFc","HD":"DynamicRating_HD_3hp-I"};